export const MEMBER_ENTRY_MEAN_CODE = {
  SABUN: '10', // 사번인증
  EMAIL: '20', // 이메일인증
  ALL: '30', // 사번&이메일인증
  NOTHING: '40', // 인증x
  COUPON: '50', // 쿠폰인증
  BRANCH: '60', // 단체코드인증
};

// 인증코드 목록 (40만 제외)
export const MEMBER_ENTRY_MEAN_CODE_LIST = Object.values(MEMBER_ENTRY_MEAN_CODE).filter(
  (code) => code !== MEMBER_ENTRY_MEAN_CODE.NOTHING
);
